import { CreateFieldService } from "types/business/CreateFieldService";
import { BehaviorSubject } from "types/libReplace/BehaviorSubject";
import { createUseDefaultObservable } from "utils/libExtend/createUseDefaultObservable";

type CurrentType = CreateFieldService[];

export const useDefaultObservableCreateFieldServiceArray = createUseDefaultObservable<CurrentType>();

export class BehaviorSubjectCreateFieldServiceArray extends BehaviorSubject<CurrentType> {}
